import {
  AppBar,
  Toolbar,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  Box,
  Typography,
  Container,
  Button,
  useScrollTrigger,
  alpha,
  useTheme,
  List,
  ListItem
} from "@mui/material";
import MenuIcon from '@mui/icons-material/Menu';
import MemoryIcon from '@mui/icons-material/Memory';
import LogoutIcon from '@mui/icons-material/Logout';
import { useNavigate, Link as RouteLink } from "react-router-dom";
import { useAuth, useNavAccess } from '@/hooks';
import React from 'react';

import { useSettings } from "@/app/contexts/SettingContext";

export const Header = () => {
  const { canAccess } = useNavAccess();
  const settings = useSettings();
  const pages = [
    {
      label: 'Services',
      path: '/#services'
    },
    {
      label: 'Industries',
      path: '/#industries'
    },
    {
      label: 'Academy',
      path: '/academy'
    },
    {
      label: 'Careers',
      path: 'https://www.linkedin.com/company/132024197/admin/posted-jobs/open/',
      target: '_blank',
    }
  ];
  const navigate = useNavigate();
  const scrolled = useScrollTrigger({ disableHysteresis: true, threshold: 12 });
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const settingMenu = [{
    item: "Profile",
    onClick:(() => navigate('/profile'))
  }];
  const { isAuthenticated, user, logout } = useAuth();
  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const [anchorElNav, setAnchorElNav] = React.useState<null | HTMLElement>(null);

  const handleLogout = async () => {
    setAnchorElUser(null);
    await logout();
    navigate('/auth/login');
  };

  const handleOpenNavMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const visiblePages = pages.filter((page) => canAccess(page));

  return (
    <AppBar
      position="sticky"
      sx={{
        top: 0,
        bgcolor: scrolled ? alpha(theme.palette.background.default, isDark ? 0.84 : 0.9) : theme.palette.background.default,
        color: theme.palette.text.primary,
        borderBottom: `1px solid ${theme.palette.divider}`,
        boxShadow: scrolled ? theme.palette.baseShadow : 'none',
        backdropFilter: scrolled ? 'blur(18px)' : 'none',
      }}
    >
      <Container maxWidth="lg">
        <Toolbar disableGutters sx={{
          gap: 2,
          minHeight: { xs: 64, md: 74 },
        }}>
          <Box
            sx={{ 
              flexGrow: { xs: 1, md: 0 },
            }}  
          >
            <Box 
              component={RouteLink}
              to="/"
              sx={{
                alignItems: 'center', 
                display: 'flex', 
                textDecoration: 'none',
                color: 'inherit',
              }}
            >
              <Box 
                component="img"
                src="/img/crazymodifier-enterprises-logo.png"
                alt="Example"
                sx={{
                  width: 70,
                  height: 'auto',
                  mr: 1
                }}/>
              <Typography 
                variant="h3" 
                sx={{
                  fontWeight:600
                }}
                >
                {settings?.site_name || 'CrazyModifier'}
              </Typography>
            </Box>
          </Box>

          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{
                padding: 0,
                color: 'text.primary',
              }}
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {visiblePages.map((page) => (
                <MenuItem
                  key={page.label}
                  onClick={handleCloseNavMenu}
                  component="a"
                  href={page.path}
                  target={page.target}
                >
                  <Typography sx={{ textAlign: 'center' }} variant="body2">{page.label}</Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <Box 
            sx={{ 
              flexGrow: 1, 
              display: { xs: 'none', md: 'flex' },
              justifyContent: 'end'
            }}
          >
            <List
              sx={{
                display: 'flex',
                flexDirection: 'row',
              }}
            >
            
            {visiblePages.map((page) => (
              // <Button
              //   key={page}
              //   component="a"
              //   href={page === 'Home' ? '/' : `#${page.toLowerCase()}`}
              //   onClick={handleCloseNavMenu}
              //   sx={{
              //     color: 'text.secondary',
              //     fontWeight: 500,
              //     textTransform: 'none',
                  
              //     '&:hover': {
              //       color: 'text.primary',
              //     },
              //   }}
              // >
              //   {page}
              // </Button>
              <ListItem
                key={page.label}
                component="a"
                href={page.path}
                target={page.target}

                sx={{
                  color: 'text.secondary',
                  fontWeight: 600,
                  textTransform: 'none',
                  fontSize: '0.875rem',
                  cursor: 'pointer',
                  '&:hover': {
                    color: 'text.primary',
                  },
                  "&:last-child": {
                    mr: -2,
                  }
                }}>
                  {page.label}
              </ListItem>
            ))}
          </List>
          </Box>
          {/* 
          {isAuthenticated ? (
            <Box sx={{ flexGrow: 0,  order: 2,  }}>
              <Avatar
                onClick={(e) => setAnchorElUser(e.currentTarget)}
                sx={{ width: 40, height: 40, cursor: 'pointer', bgcolor: 'secondary.main' }}
              >
                {user?.name?.charAt(0).toUpperCase()}
              </Avatar>
              <Menu
                sx={{ mt: '45px' }}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                keepMounted
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                anchorEl={anchorElUser}
                open={Boolean(anchorElUser)}
                onClose={() => setAnchorElUser(null)}>
                <MenuItem disabled>
                    <Box>
                      <Box sx={{ fontWeight: 500 }}>{user?.name}</Box>
                      <Box sx={{ fontSize: '0.85rem', color: '#6b7280' }}>{user?.email}</Box>
                    </Box>
                  </MenuItem>
                {settingMenu.map((setting) => (
                  <MenuItem key={setting.item} onClick={setting.onClick}>
                    <Typography sx={{ textAlign: 'center' }}>{setting.item}</Typography>
                  </MenuItem>
                ))}
                <MenuItem onClick={handleLogout}>
                  <LogoutIcon sx={{ mr: 1 }} /> Logout
                </MenuItem>
              </Menu>
            </Box>
          ):(
            <Box sx={{ flexGrow: 0, order: 2 }}>
              <Button
                component={RouteLink}
                to="/auth/login"
                variant="outlined"
                sx={{
                  color: 'text.primary',
                  borderColor: alpha(theme.palette.primary.main, 0.58),
                  textTransform: 'none',
                  fontWeight: 800,
                  '&:hover': {
                    borderColor: 'primary.main',
                    bgcolor: alpha(theme.palette.primary.main, 0.1),
                  },
                }}
              >
                Login
              </Button>
            </Box>
          )}
           */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default Header;
